"use strict";
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
var _preact = require("preact");
var TRANSITION_MS = 300;
var FadeIn = /*#__PURE__*/ function(_preact_Component) {
    _inherits(FadeIn, _preact_Component);
    function FadeIn() {
        _class_call_check(this, FadeIn);
        var _this;
        _this = _call_super(this, FadeIn, arguments);
        _this.ref = (0, _preact.createRef)();
        return _this;
    }
    _create_class(FadeIn, [
        {
            key: "componentWillEnter",
            value: function componentWillEnter(callback) {
                this.ref.current.style.opacity = '1';
                this.ref.current.style.transform = 'none';
                setTimeout(callback, TRANSITION_MS);
            }
        },
        {
            key: "componentWillLeave",
            value: function componentWillLeave(callback) {
                this.ref.current.style.opacity = '0';
                this.ref.current.style.transform = 'translateY(350%)';
                setTimeout(callback, TRANSITION_MS);
            }
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return (0, _preact.h)("div", {
                    className: "uppy-Informer-animated",
                    ref: this.ref
                }, children);
            }
        }
    ]);
    return FadeIn;
}(_preact.Component);
module.exports = FadeIn;
